import { IconWrapper } from '../runtime';
export default IconWrapper('maximize', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M1.76504 3.75C1.76504 2.92157 2.43661 2.25 3.26504 2.25H12.765C13.5935 2.25 14.265 2.92157 14.265 3.75L14.25 12.25C14.25 13.0784 13.5784 13.75 12.75 13.75H3.25C2.42157 13.75 1.75 13.0784 1.75 12.25L1.76504 3.75Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});